import React, { useCallback } from 'react';
import { _ } from '@splunk/ui-utils/i18n';
import TrashCanCross from '@splunk/react-icons/TrashCanCross';
import { ActionButton, useActionButtonClick } from '../ActionButton';
import type { BaseButtonProps } from '../BaseButton';
import { getButtonTitle } from '../utils/getButtonTitle';

const deleteIcon = <TrashCanCross />;

export const DeleteButton = ({
    itemId,
    dashboardApi,
    screenReaderText,
    ...rest
}: BaseButtonProps): JSX.Element | null => {
    const deleteItem = useCallback(() => {
        // dashboardApi and itemId have to exist to execute this callback
        if (!itemId || !dashboardApi) {
            return;
        }
        dashboardApi.removeDashboardItemsWithPrompt([itemId]);
    }, [dashboardApi, itemId]);

    const handleOnClick = useActionButtonClick('delete', deleteItem);

    const buttonTitle = getButtonTitle({
        base: _('Delete'),
        screenReaderText,
    });

    if (itemId == null || dashboardApi == null) {
        return null;
    }

    return (
        <ActionButton
            {...rest}
            data-test="delete-button"
            onClick={handleOnClick}
            icon={deleteIcon}
            title={buttonTitle}
        />
    );
};
